{
    "title": "LOGIN",
    "textFieldsLable": {
        "userName": "Username",
        "password": "Password"
    },
    "placeHolders": {
        "userName": "Enter Username",
        "password": "Enter Password"
    },
    "validationMsgs": {
        "userName": "Username is required",
        "password": "Password is required"
    },
    "forgotPswd":"Forgot Password?",
    "resetBtn":{
        "lable": "Reset"
    },
    "submit":{
        "lable":"Login"
    }
}